if (!window.Eurus.loadedScript.has('quantity-selector.js')) {
  window.Eurus.loadedScript.add('quantity-selector.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xQuantitySelector', (
        productId,
        sectionId,
        qtyRuleMin,
        qtyRuleMax,
        currencyCodeEnable,
        moneyWithCurrency,
        moneyFormat
      ) => ({
        qty: qtyRuleMin,
        min: qtyRuleMin,
        max: qtyRuleMax,
        initQtyChangeEvent(selector) {
          this.$nextTick(() => { 
            this.qty = document.getElementById(selector)?.value;
            document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, (e) => {
              this.qty = e.detail.quantity;
            })
          });
        },
        minus(value) {
          if(this.qty <= this.min) {
            this.qty = this.min;
          } else {
            this.qty = parseInt(this.qty);
            (this.qty == 1) ? this.qty = 1 : this.qty -= value;
          }
          this.updatePrice();
        },
        plus(value) {
          if(this.max != null && this.qty >= this.max) {
            this.qty = parseInt(this.max);
          } else {
            this.qty = parseInt(this.qty);
            this.qty += value;
          }
          this.updatePrice();
        },
        invalid(el) {
          number = parseFloat(el.value);
          if (!Number.isInteger(number) || number < this.min) {
            this.qty = this.min;
          }
          if (this.max != null && number > this.max) {
            this.qty = parseInt(this.max);
          }
          this.updatePrice();
        },
        updatePrice() {
          const product_template = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          const money_format = currencyCodeEnable ? moneyWithCurrency : moneyFormat;

          // `.target-price`/`.target-compare-at-price` come from
          // snippets/price.liquid, but for wholesale shoppers the BSS B2B app
          // overwrites that price container's innerHTML with its own markup
          // to show the wholesale price — wiping those hidden helper divs out.
          // Read them defensively instead of assuming they survived, so a B2B
          // shopper changing quantity doesn't crash before the event below
          // ever fires.
          const getPrice = (selector) => {
            const el = product_template.querySelector(selector);
            return el ? Number(el.innerHTML) * this.qty : null;
          };
          const update = (selector, value) => {
            const el = product_template.querySelector(selector);
            if (el) el.innerHTML = value;
          };

          const rawPrice = getPrice('.target-price');
          const rawComparePrice = getPrice('.target-compare-at-price');

          if (rawPrice !== null) {
            let product_price = Alpine.store('xHelper').formatMoney(rawPrice, money_format);
            update('.add_to_cart_button .main-product-price .price', product_price);
            update('.add_to_cart_button .main-product-price .price-sale', product_price);
          }
          if (rawComparePrice !== null) {
            let product_compare_at_price = Alpine.store('xHelper').formatMoney(rawComparePrice, money_format);
            update('.add_to_cart_button .main-product-price .price-compare', product_compare_at_price);
          }

          document.dispatchEvent(new CustomEvent(`quantity:changed-${sectionId}`, {
            detail: {
              qty: this.qty
            }
          }));
        },
      }));
    })
  });
}    